import { useEffect, useState } from "react";
import { useRouter } from "next/router";

export const CALENDAR_LINKS = {
  DEFAULT: "https://cal.com/team/builtright/launch",
  BCBA_PARTNER: "https://cal.com/team/builtright/get-a-builtright-bcba-site",
  EWINING_PARTNER: "https://cal.com/team/builtright/get-an-ewing-builtright-site",
  NTCA_PARTNER: "https://cal.com/team/builtright/get-a-ntca-builtright-site",
  STRIPE_PARTNER: "https://cal.com/team/builtright/get-a-builtright-stripe-life-site",
} as const;

type CalendarLink = (typeof CALENDAR_LINKS)[keyof typeof CALENDAR_LINKS];

interface UseCalendarLinkReturn {
  calendarLink: CalendarLink;
  calPath: string;
  psxId: string;
}

export function useCalendarLink(): UseCalendarLinkReturn {
  const router = useRouter();
  const [calendarLink, setCalendarLink] = useState<CalendarLink>(CALENDAR_LINKS.DEFAULT);
  const [psxId, setPsxId] = useState("");

  useEffect(() => {
    // Check if we're in a browser environment and localStorage is available
    const isBrowser = typeof window !== "undefined";
    const isLocalStorageAvailable = isBrowser && window?.localStorage;
    if (!isLocalStorageAvailable) return;

    const queryPsxId = Array.isArray(router?.query?.ps_xid) ? router?.query?.ps_xid[0] : (router?.query?.ps_xid ?? "");

    // psxId is dynamically generated from partnerstack
    // if the psxId is not in the localStorage but is in the query param
    // we persist it to localStorage OR if the psxId in the localStorage is different from the query param
    // we persist the new psxId in localStorage
    if (
      (!localStorage.getItem("ps_xid") && queryPsxId) ||
      (queryPsxId && localStorage.getItem("ps_xid") !== queryPsxId)
    ) {
      localStorage.setItem("ps_xid", queryPsxId as string);
    }

    setPsxId(localStorage.getItem("ps_xid") ?? "");

    try {
      const link = CALENDAR_LINKS.DEFAULT;
      setCalendarLink(link);
    } catch (error) {
      console.warn("Failed to access localStorage:", error);
      setCalendarLink(CALENDAR_LINKS.DEFAULT);
    }
  }, [router?.query?.ps_xid]);

  return { calendarLink, calPath: calendarLink.replace("https://cal.com/", ""), psxId };
}
